/**
 * @generated SignedSource<<ef934362fd4107a0119768015fc53f28>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ProjectTypeCell$data = {
  readonly projectStyle: JiraProjectStyle | null | undefined;
  readonly projectType: JiraProjectType | null | undefined;
  readonly " $fragmentType": "ProjectTypeCell";
};
export type ProjectTypeCell$key = {
  readonly " $data"?: ProjectTypeCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectTypeCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ProjectTypeCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "projectStyle"
    },
    {
      "kind": "ScalarField",
      "name": "projectType"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "5140e54160d0df36f8efcb7472bafa65";

export default node;
